const isLocalLink = (url) => url && typeof url === 'string' && url.startsWith('/') && url.indexOf('http') === -1 && url.indexOf('https') === -1;

export default isLocalLink;
